import { render } from "./AMLReport.vue?vue&type=template&id=7b6bfb60"
import script from "./AMLReport.vue?vue&type=script&lang=js"
export * from "./AMLReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__